import { ErrorHandler, inject } from "@angular/core";
import { Router } from "@angular/router";
import { getLoggerFor } from "@tylertech/logging";

export class GlobalErrorHandler implements ErrorHandler
{
    private readonly log = getLoggerFor("GlobalErrorHandler");
    private readonly router = inject(Router);

    handleError(error: unknown): void
    {
        // ? TODO - If we ever want to try sending uncaught errors to KB, then we should probably do it here.

        const url = this.router.url;
        if (error instanceof Error)
        {
            this.log.error(
                error.message,
                {
                    eventName: 'Error',
                    url,
                    message: error.message,
                    stack: error.stack.split(/\r?\n/),
                });
            this.log.error(error);
            return;
        }

        this.log.error("Unhandled Exception", {
            eventName: 'Error',
            url,
        });
        this.log.error(error);

    }
}
